module.exports = __webpack_public_path__ + "static/media/logo_print.f93f2633.png";